export const routes = {
  home: '/',
  collection: '/collection',
  product: (slug) => `/product/${slug}`,
  about: '/about',
  contact: '/contact',
  terms: '/terms',
  privacy: '/privacy',
  checkout: '/checkout',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  orders: '/orders',
  profile: '/profile',
  forbidden: '/403',
  admin: {
    login: '/core-site/admin/login',
    dashboard: '/core-site/admin',
    products: '/core-site/admin/products',
    productNew: '/core-site/admin/products/new',
    productEdit: (slug) => `/core-site/admin/products/${slug}/edit`,
    orders: '/core-site/admin/orders',
    orderDetail: (ref) => `/core-site/admin/orders/${ref}`,
    reviews: '/core-site/admin/reviews',
    testimonials: '/core-site/admin/testimonials',
    settings: '/core-site/admin/settings',
    account: '/core-site/admin/account',
  },
};
